export const catalogList = [
  {
    title: "Featured",
    icon: "coin",
    items: [
      {
        title: "The grand resort",
        location: "Karineside",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "5.0",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "East Barrett",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.8",
        image: "/images/content/catalog-pic-2.jpg",
        image2x: "/images/content/catalog-pic-2@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Steuberbury",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-3.jpg",
        image2x: "/images/content/catalog-pic-3@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Idaview",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.8",
        image: "/images/content/catalog-pic-4.jpg",
        image2x: "/images/content/catalog-pic-4@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Yasminfurt",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-5.jpg",
        image2x: "/images/content/catalog-pic-5@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "North Edenshire",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-6.jpg",
        image2x: "/images/content/catalog-pic-6@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Archibaldtown",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.8",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "West Gregoria",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-7.jpg",
        image2x: "/images/content/catalog-pic-7@2x.jpg",
        url: "/stays-product",
      },
    ],
  },
  {
    title: "Family-friendly",
    icon: "coin",
    items: [
      {
        title: "The grand resort",
        location: "Karineside",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "5.0",
        image: "/images/content/catalog-pic-7.jpg",
        image2x: "/images/content/catalog-pic-7@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "East Barrett",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-6.jpg",
        image2x: "/images/content/catalog-pic-6@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Steuberbury",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-3.jpg",
        image2x: "/images/content/catalog-pic-3@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Idaview",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-4.jpg",
        image2x: "/images/content/catalog-pic-4@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Yasminfurt",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.8",
        image: "/images/content/catalog-pic-5.jpg",
        image2x: "/images/content/catalog-pic-5@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "North Edenshire",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-2.jpg",
        image2x: "/images/content/catalog-pic-2@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Archibaldtown",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "West Gregoria",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
    ],
  },
  {
    title: "On sale",
    icon: "coin",
    items: [
      {
        title: "The grand resort",
        location: "Karineside",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "East Barrett",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-2.jpg",
        image2x: "/images/content/catalog-pic-2@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Steuberbury",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-4.jpg",
        image2x: "/images/content/catalog-pic-4@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Idaview",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-3.jpg",
        image2x: "/images/content/catalog-pic-3@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Yasminfurt",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "North Edenshire",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "5.0",
        image: "/images/content/catalog-pic-6.jpg",
        image2x: "/images/content/catalog-pic-6@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Archibaldtown",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "West Gregoria",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-7.jpg",
        image2x: "/images/content/catalog-pic-7@2x.jpg",
        url: "/stays-product",
      },
    ],
  },
  {
    title: "Sub nav",
    icon: "coin",
    items: [
      {
        title: "The grand resort",
        location: "Karineside",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-4.jpg",
        image2x: "/images/content/catalog-pic-4@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "East Barrett",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Steuberbury",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-3.jpg",
        image2x: "/images/content/catalog-pic-3@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Idaview",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-7.jpg",
        image2x: "/images/content/catalog-pic-7@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Yasminfurt",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-5.jpg",
        image2x: "/images/content/catalog-pic-5@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "North Edenshire",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-6.jpg",
        image2x: "/images/content/catalog-pic-6@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "Archibaldtown",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-1.jpg",
        image2x: "/images/content/catalog-pic-1@2x.jpg",
        url: "/stays-product",
      },
      {
        title: "The grand resort",
        location: "West Gregoria",
        priceOld: "$699",
        priceActual: "$548",
        date: "Tue, Jul 20 - Fri, Jul 23",
        rating: "4.9",
        image: "/images/content/catalog-pic-2.jpg",
        image2x: "/images/content/catalog-pic-2@2x.jpg",
        url: "/stays-product",
      },
    ],
  },
];
